import React, { useState } from "react";
import { Search, Edit, Plus, X } from "lucide-react";
export default function Discountsone() {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    discountType: "All",
    vendor: "All",
    couponCode: "",
    discountName: "",
    isActive: "All",
  });
  const [discounts, setDiscounts] = useState([
    {
      name: "20% order total discount",
      type: "Assigned to order",
      discount: "20%",
      start: "01/01/2010 12:00 AM",
      end: "01/01/2020 12:00 AM",
      used: 0,
      active: true,
    },
    {
      name: "Sample discount with coupon code",
      type: "Assigned to product",
      discount: "10 USD",
      start: "-",
      end: "-",
      used: 0,
      active: true,
    },
  ]);
  const [editing, setEditing] = useState(null); // holds the item being edited
  const [formData, setFormData] = useState({});
  const handleEdit = (item, index) => {
    setEditing(index);
    setFormData(item);
  };
  const handleSave = () => {
    const updated = [...discounts];
    updated[editing] = formData;
    setDiscounts(updated);
    setEditing(null);
  };
  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Discounts</h1>
        <button className="mt-3 sm:mt-0 flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md shadow">
          <Plus size={18} /> Add new
        </button>
      </div>
      {/* Search Section */}
      <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="flex items-center gap-2 mb-4 text-gray-700 font-medium">
          <Search size={18} /> Search
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="text-sm font-medium">Start date</label>
            <input
              type="date"
              className="w-full mt-1 p-2 border rounded-md text-sm"
            />
          </div>
          <div>
            <label className="text-sm font-medium">End date</label>
            <input
              type="date"
              className="w-full mt-1 p-2 border rounded-md text-sm"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Discount type</label>
            <select className="w-full mt-1 p-2 border rounded-md text-sm">
              <option>All</option>
              <option>Assigned to order</option>
              <option>Assigned to product</option>
              <option> Assigned to Categories</option>
              <option> Assigned to Manufacturers</option>
              <option> Assigned to Shipping</option>
              <option> Assigned to Order subtotal</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium">Vendor</label>
            <select className="w-full mt-1 p-2 border rounded-md text-sm">
              <option>All</option>
              <option>Vendor 1</option>
              <option>Vendor 2</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium">Coupon code</label>
            <input
              type="text"
              placeholder="Enter code"
              className="w-full mt-1 p-2 border rounded-md text-sm"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Discount name</label>
            <input
              type="text"
              placeholder="Enter name"
              className="w-full mt-1 p-2 border rounded-md text-sm"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Is active</label>
            <select className="w-full mt-1 p-2 border rounded-md text-sm">
              <option>All</option>
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>
        </div>
        <div className="mt-6">
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md flex items-center gap-2">
            <Search size={18} /> Search
          </button>
        </div>
      </div>
      {/* Table Section */}
      <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border border-gray-200">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="bg-gray-100 border-b text-gray-600 uppercase text-xs">
              <tr>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Discount type</th>
                <th className="px-4 py-3">Discount</th>
                <th className="px-4 py-3">Start date</th>
                <th className="px-4 py-3">End date</th>
                <th className="px-4 py-3">Times used</th>
                <th className="px-4 py-3">Is active</th>
                <th className="px-4 py-3">Edit</th>
              </tr>
            </thead>
            <tbody>
              {discounts.map((d, i) => (
                <tr
                  key={i}
                  className="border-b hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 py-3">{d.name}</td>
                  <td className="px-4 py-3">{d.type}</td>
                  <td className="px-4 py-3">{d.discount}</td>
                  <td className="px-4 py-3">{d.start}</td>
                  <td className="px-4 py-3">{d.end}</td>
                  <td className="px-4 py-3">{d.used}</td>
                  <td className="px-4 py-3 text-center">
                    {d.active ? (
                      <span className="text-green-600 font-semibold">✔</span>
                    ) : (
                      <span className="text-red-500 font-semibold">✖</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => handleEdit(d, i)}
                      className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                    >
                      <Edit size={16} /> Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
          <div>Showing 1-{discounts.length} of {discounts.length} items</div>
          <div className="flex items-center gap-2">
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 border rounded bg-blue-600 text-white hover:bg-blue-700">
              1
            </button>
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Next
            </button>
          </div>
        </div>
      </div>
      {/* Edit Modal */}
      {editing !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white w-11/12 md:w-1/2 p-6 rounded-lg shadow-lg relative">
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
              onClick={() => setEditing(null)}
            >
              <X size={20} />
            </button>
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Edit Discount</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium">Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full mt-1 p-2 border rounded-md text-sm"
                />
              </div>
              <div>
                <label className="text-sm font-medium">Discount Type</label>
                <select
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                  className="w-full mt-1 p-2 border rounded-md text-sm"
                >
                  <option>Assigned to order</option>
                  <option>Assigned to product</option>
                  <option>Categories</option>
                  <option>Manufacturers</option>
                  <option>Shipping</option>
                  <option>Order subtotal</option>
                </select>
              </div>
              <div>
                <label className="text-sm font-medium">Discount</label>
                <input
                  type="text"
                  value={formData.discount}
                  onChange={(e) =>
                    setFormData({ ...formData, discount: e.target.value })
                  }
                  className="w-full mt-1 p-2 border rounded-md text-sm"
                />
              </div>
              <div>
                <label className="text-sm font-medium">Active</label>
                <select
                  value={formData.active ? "Yes" : "No"}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      active: e.target.value === "Yes",
                    })
                  }
                  className="w-full mt-1 p-2 border rounded-md text-sm"
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setEditing(null)}
                className="px-4 py-2 border rounded-md hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
